import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import Receita from './receita';
import { useReceita, IReceita } from '../../hooks/receita';
import { useToast } from '../../hooks/toast';
import getResponseErrors from '../../utils/getResponseErrors';
import Loading from '../../components/Loading';

const ReceitaImpressao: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const { addToast } = useToast();
  const { buscarReceita } = useReceita();

  const [receita, setReceita] = useState<IReceita | null>(null);
  const [loading, setLoading] = useState(true);
  const [cliCodigo, setCliCodigo] = useState<number>();

  const query = new URLSearchParams(location.search);
  const duasVias = query.get('vias') === '2';

  useEffect(() => {
    async function loadDados(): Promise<void> {
      setLoading(true);
      try {
        const data = await buscarReceita(Number(id));
        setReceita(data);
        setCliCodigo(data.RecUsuCodigo);
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          type: 'error',
          title: 'Erro ao carregar receita',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    }
    if (id) {
      loadDados();
    }
  }, [id, buscarReceita, addToast]);

  useEffect(() => {
    if (receita && !loading) {
      setTimeout(() => {
        window.print();
      }, 500);
    }
  }, [receita, loading]);

  if (!id) {
    return <div className="p-3 text-center">ID da receita não informado</div>;
  }

  return (
    <div className={duasVias ? 'd-flex justify-content-between' : ''}>
      {loading && <Loading />}
      {receita && <Receita receita={receita} />}

      {duasVias && (
        <>
          {loading && <Loading />}
          {receita && <Receita receita={receita} />}
        </>
      )}
    </div>
  );
};

export default ReceitaImpressao;
